import { ArrowRight, MapPin } from "lucide-react";

const cities = ["Delhi NCR", "Hyderabad", "Bengaluru", "Chennai"];

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative min-h-screen flex items-end pb-16 sm:pb-24 overflow-hidden"
        >
            {/* Background image */}
            <div className="absolute inset-0">
                <img
                    src="https://images.unsplash.com/photo-1722851152653-1182e178a81f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBza3lzY3JhcGVyJTIwY2l0eXNjYXBlJTIwbmlnaHR8ZW58MHx8fHwxNzgzNDkxMDcyfDA&ixlib=rb-4.1.0&q=85"
                    alt="India real estate skyline"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-[#050507]" />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-black/40" />
            </div>

            {/* Content */}
            <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 w-full pt-32">
                <div className="grid lg:grid-cols-12 gap-12 items-end">
                    <div className="lg:col-span-8 animate-fadeup">
                        <div className="flex items-center gap-3 mb-8">
                            <div className="h-px w-12 bg-[#D4AF37]" />
                            <span className="overline">India · Real Estate · Since 2018</span>
                        </div>

                        <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
                            OTP-Verified Real Estate Leads.
                            <br />
                            Built Around <span className="italic text-[#D4AF37]">Your Market</span>.
                        </h1>

                        <p className="mt-8 max-w-xl text-white/70 text-base sm:text-lg leading-relaxed">
                            Lead Krafts uses AI-powered market intelligence, micro-market targeting and campaign
                            optimisation to generate higher-intent OTP-verified buyer enquiries.
                        </p>

                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <a href="#calculator" data-testid="hero-cta-calc" className="btn-gold">
                                Calculate My Indicative CPL <ArrowRight size={16} />
                            </a>
                            <a href="#how" data-testid="hero-cta-demo" className="btn-outline-gold">
                                See How It Works
                            </a>
                        </div>

                        <div className="mt-6 text-xs uppercase tracking-[0.2em] text-white/40" data-testid="hero-trust-line">
                            AI-Powered • Micro-Market Targeting • OTP-Verified Leads
                        </div>
                    </div>

                    <div className="lg:col-span-4 animate-fadeup" style={{ animationDelay: "180ms" }}>
                        <div className="border-l border-[#D4AF37]/30 pl-6 space-y-6">
                            <div>
                                <div className="font-serif-display text-3xl text-[#D4AF37] leading-tight">OTP-verified enquiries</div>
                                <div className="overline mt-2 !text-white/50">Verified before delivery</div>
                            </div>
                            <div className="gold-line" />
                            <div>
                                <div className="font-serif-display text-3xl text-[#D4AF37] leading-tight">City & micro-market targeting</div>
                                <div className="overline mt-2 !text-white/50">Priced on where you actually build</div>
                            </div>
                            <div className="gold-line" />
                            <div>
                                <div className="font-serif-display text-3xl text-[#D4AF37] leading-tight">Delivered to your CRM</div>
                                <div className="overline mt-2 !text-white/50">WhatsApp · Email · CRM webhook</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-20 border-t border-white/10 pt-6 flex items-center gap-3 flex-wrap">
                    <MapPin size={14} className="text-[#D4AF37]" />
                    <span className="overline !text-white/50">Active Markets</span>
                    {cities.map((c, i) => (
                        <span key={c} className="text-sm text-white/60 font-body">
                            {c}
                            {i < cities.length - 1 && <span className="text-white/20 mx-2">·</span>}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
